export const environment = {
  production: false,
  client_id: 'yield-client',
  client_secret: 'yield-secret',
  autoMl:"",
  skipOauth: false,
  chatbotHost:"http://20.62.197.230:8007",
  rootCauseHost:"http://143.198.186.210:6001",
  enableUserLog: true,
  devicePulse: false,
  host: 'https://yield.senzmatica.com/service',
  testHost: 'https://yield.senzmatica.com/service',
  azureAd: {
    clientId: '07b0d9b8-19bf-43ad-a468-d9ad0d19048b',
    tenantId: 'common',
  },
  azurepackageFreeId: "planid_01",
  azurepackageBasicId: "planid_02",
  azurepackagePremiumId: "plan_premium_001",
  azurePackageUpgradeLink:"",
  azurepageLink: "https://azuremarketplace.microsoft.com/en-us/marketplace/apps/senzmate.00-222-1919-preview?tab=Overview&flightCodes=4aebb105-27dc-4589-a9f7-c4770f931e7f",
  contactUsLink: "",

  firebase: {
    apiKey: 'AIzaSyA9uKFEIqgW63abTdvYTqb3gS6r-60FRpI',
    authDomain: 'senzagro-c3d33.firebaseapp.com',
    databaseURL: 'https://senzagro-c3d33.firebaseio.com',
    projectId: 'senzagro-c3d33',
    storageBucket: 'senzagro-c3d33.appspot.com',
    messagingSenderId: '283658892245',
    appId: '1:283658892245:web:e206dc51d4a2719e75c35c',
    measurementId: 'G-E5NKHDMS7N'
  },
  useFirebase:true
};
